import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { marked } from "marked";
import CustomTooltip from "../Tooltip/CustomTooltip";

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      const html = marked.parse(text);
      const clipboardItem = new ClipboardItem({
        "text/plain": new Blob([text], { type: "text/plain" }),
        "text/html": new Blob([html], { type: "text/html" }),
      });


      await navigator.clipboard.write([clipboardItem]);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      navigator.clipboard.writeText(text);
    }
  }
  return (
    <CustomTooltip
      content={copied ? "Copied!" : "Copy response"}
      side="top"
      align="center"
    >
      <button
        type="button"
        onClick={handleCopy}
        aria-label={copied ? "Copied to clipboard" : "Copy response"}
        size="small"
        disabled={copied}
      >
        <div
          className={`p-2 rounded-full transition-colors ${copied
            ? "bg-button-copy-surface/25 dark:bg-button-copy-surface"
            : "hover:bg-button-copy-surface/25 dark:hover:bg-button-copy-surface/100"
            }`}
        >
          {copied
            ? <Check className="w-4 h-4 text-button-control-text" />
            : <Copy className="w-4 h-4 hover:scale-110 transition-transform" />}
        </div>
      </button>
    </CustomTooltip>
  );
};

export default CopyButton;
